<template>
  <div class="pay">
    <div class="btn" @click="data.open">返回APP</div>
  </div>
</template>

<script setup>
import {
  ref,
  reactive,
  toRefs,
  onBeforeMount,
  onMounted,
  watchEffect,
  computed,
  defineComponent,
  defineExpose,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import { orderOn, wxpay } from "@/api/recharge";
import { setToken, removeToken } from "@/ulits/auth";
defineComponent({
  name: "",
});
/**
 * 路由对象
 */
const route = useRoute();
/**
 * 路由实例
 */
const router = useRouter();
//console.log('1-开始创建组件-setup')
/**
 * 数据部分
 */
const data = reactive({});

data.open = () => {
  window.open('huajiaielves://huajiwang')
}

console.log(route.query);
if (route.query.token) {
  setToken(route.query.token);
}
data.pay = () => {
  orderOn({
    user_id: route.query.userid,
    content_id: route.query.contentId,
  }).then((res) => {
    if (res.code === 200) {
      const pay_content = {
        api_type: 3,
        type: "H5",
      };
      data.wxpayFunction(res.data, pay_content);
    }
  });
};

data.wxpayFunction = (no, pay_content) => {
  wxpay({
    source_type: 1,
    trade_no: no,
    pay_content: pay_content,
  }).then((res) => {
    if (res.code === 200) {
      removeToken();
      window.location.href = res.data.weipay;
    }
  });
};

onBeforeMount(() => {
  //console.log('2.组件挂载页面之前执行----onBeforeMount')
});
onMounted(() => {
  if (route.query.token) {
    data.pay();
  }
  //console.log('3.-组件挂载到页面之后执行-------onMounted')
});
watchEffect(() => {});
// 使用toRefs解构
// let { } = { ...toRefs(data) }
defineExpose({
  ...toRefs(data),
});
</script>
<style lang="scss" scoped>
.pay {
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 320px);
  .btn {
    background: #32a6ef;
    color: #ffffff;
    border-radius: 15px;
    padding: 10px 20px;
  }
}
</style>
